const Labels = (() => {
  const fields = Array.from(document.querySelectorAll('.c-form-field-text, .c-form-field-select'));

  return {
    init: () => {
      if (fields.length > 0) { 
        fields.forEach(field => {
          let input = field.querySelector('input, textarea, select');
          if (input.value !== "") {
            field.classList.add('is-dirty');
          }
          input.addEventListener('focus', () => {
            field.classList.add('is-focused');
          });
          input.addEventListener('blur', () => {
            if (input.value !== "") {
              field.classList.add('is-dirty');
              field.classList.remove('is-focused');
            } else {
              field.classList.remove('is-dirty');
              field.classList.remove('is-focused');
            }
          });
        })
      }
    }
  }
})();

export default Labels;


// WEBPACK FOOTER //
// ./src/js/components/labels.js